import axios from "../../axios/axios";

import * as apis from "../../apis";
import * as errors from "../../errors";
import * as successes from "../../successes";

import {notifyError, notifySuccess} from "../../toast-notifications";
import {getAxiosTokenConfig} from "../../helpers";


// TOGGLE DEFAULT SHIFT MODAL
export const TOGGLE_DEFAULT_SHIFT_MODAL = "TOGGLE_DEFAULT_SHIFT_MODAL";

export const toggleDefaultShiftModal = () => {
    return dispatch => {
        dispatch({type: TOGGLE_DEFAULT_SHIFT_MODAL})
    }
}

// TOGGLE CUSTOM SHIFT MODAL
export const TOGGLE_CUSTOM_SHIFT_MODAL = "TOGGLE_CUSTOM_SHIFT_MODAL";

export const toggleCustomShiftModal = () => {
    return dispatch => {
        dispatch({type: TOGGLE_CUSTOM_SHIFT_MODAL})
    }
}

// TOGGLE CLOSED DAY MODAL
export const TOGGLE_CLOSED_DAY_MODAL = "TOGGLE_CLOSED_DAY_MODAL";

export const toggleClosedDayModal = () => {
    return dispatch => {
        dispatch({type: TOGGLE_CLOSED_DAY_MODAL})
    }
}

// GET SHIFTS
export const GET_SHIFTS_REQUEST = "GET_SHIFTS_REQUEST";
export const GET_SHIFTS_SUCCESS = "GET_SHIFTS_SUCCESS";
export const GET_SHIFTS_ERROR = "GET_SHIFTS_ERROR";

export const getShiftsRequest = () => {
    return {
        type: GET_SHIFTS_REQUEST,
        loading: true
    };
};
export const getShiftsSuccess = (shifts) => {
    return {
        type: GET_SHIFTS_SUCCESS,
        loading: false,
        error: null,
        shifts
    };
};
export const getShiftsError = (error) => {
    return {
        type: GET_SHIFTS_ERROR,
        loading: false,
        error
    };
};
export const getShifts = () => {
    return dispatch => {
        dispatch(getShiftsRequest());
        axios.get(apis.GET_SHIFTS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getShiftsSuccess(response.data));
            })
            .catch(error => {
                dispatch(getShiftsError(errors.GET_SHIFTS_ERROR));
                notifyError(errors.GET_SHIFTS_ERROR);
            });
    }
};

// ADD SHIFT
export const ADD_SHIFT_REQUEST = "ADD_SHIFT_REQUEST";
export const ADD_SHIFT_SUCCESS = "ADD_SHIFT_SUCCESS";
export const ADD_SHIFT_ERROR = "ADD_SHIFT_ERROR";

export const addShiftRequest = () => {
    return {
        type: ADD_SHIFT_REQUEST,
        loading: true
    };
};
export const addShiftSuccess = (shift, deletedShiftIds=[]) => {
    return {
        type: ADD_SHIFT_SUCCESS,
        loading: false,
        error: null,
        shift,
        deletedShiftIds
    };
};
export const addShiftError = (error) => {
    return {
        type: ADD_SHIFT_ERROR,
        loading: false,
        error
    };
};
export const addShift = (shift, skipToggle=false) => {
    return dispatch => {
        dispatch(addShiftRequest());
        axios.post(apis.ADD_SHIFT_API, shift, getAxiosTokenConfig())
            .then(response => {
                dispatch(addShiftSuccess(response.data, shift.deleted_conflict_ids));
                notifySuccess(successes.ADD_SHIFT_SUCCESS)
            })
            .catch(error => {
                dispatch(addShiftError(errors.ADD_SHIFT_ERROR));
                notifyError(errors.ADD_SHIFT_ERROR);
            })
            .finally(() => {
                if(skipToggle)
                    return;
                if (shift.date) {
                    dispatch(toggleCustomShiftModal())
                }
                else {
                    dispatch(toggleDefaultShiftModal())
                }
            });
    }
};

// UPDATE SHIFT
export const UPDATE_SHIFT_REQUEST = "UPDATE_SHIFT_REQUEST";
export const UPDATE_SHIFT_SUCCESS = "UPDATE_SHIFT_SUCCESS";
export const UPDATE_SHIFT_ERROR = "UPDATE_SHIFT_ERROR";

export const updateShiftRequest = () => {
    return {
        type: UPDATE_SHIFT_REQUEST,
        loading: true
    };
};
export const updateShiftSuccess = (shift, deletedShiftIds=[]) => {
    return {
        type: UPDATE_SHIFT_SUCCESS,
        loading: false,
        error: null,
        shift,
        deletedShiftIds
    };
};
export const updateShiftError = (error) => {
    return {
        type: UPDATE_SHIFT_ERROR,
        loading: false,
        error
    };
};
export const updateShift = (shift, skipToggle=false) => {
    return dispatch => {
        dispatch(updateShiftRequest());
        // Exctracting parentShift for some reason.
        const { shift: _parentShift, ...newShift } = shift ?? {};

        axios.patch(apis.UPDATE_SHIFT_API + shift.id + "/", newShift, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateShiftSuccess(response.data, shift.deleted_conflict_ids));
                notifySuccess(successes.UPDATE_SHIFT_SUCCESS)
            })
            .catch(error => {
                dispatch(updateShiftError(errors.UPDATE_SHIFT_ERROR));
                notifyError(errors.UPDATE_SHIFT_ERROR);
            })
            .finally(() => {
                if(skipToggle)
                    return;
                shift.shift ? dispatch(toggleCustomShiftModal()) : dispatch(toggleDefaultShiftModal());
            });
    }
};

// DELETE SHIFT
export const DELETE_SHIFT_REQUEST = "DELETE_SHIFT_REQUEST";
export const DELETE_SHIFT_SUCCESS = "DELETE_SHIFT_SUCCESS";
export const DELETE_SHIFT_ERROR = "DELETE_SHIFT_ERROR";

export const deleteShiftRequest = () => {
    return {
        type: DELETE_SHIFT_REQUEST,
        loading: true
    };
};
export const deleteShiftSuccess = (shiftId) => {
    return {
        type: DELETE_SHIFT_SUCCESS,
        loading: false,
        error: null,
        shiftId
    };
};
export const deleteShiftError = (error) => {
    return {
        type: DELETE_SHIFT_ERROR,
        loading: false,
        error
    };
};
export const deleteShift = (shift, skipToggle=false) => {
    return dispatch => {
        dispatch(deleteShiftRequest());
        axios.delete(apis.DELETE_SHIFT_API + shift.id + "/", getAxiosTokenConfig())
            .then(response => {
                dispatch(deleteShiftSuccess(shift.id));
                notifySuccess(successes.DELETE_SHIFT_SUCCESS)
            })
            .catch(error => {
                dispatch(deleteShiftError(errors.DELETE_SHIFT_ERROR));
                notifyError(errors.DELETE_SHIFT_ERROR);
            })
            .finally(() => {
                if(skipToggle)
                    return;
                if (shift.date) {
                    dispatch(toggleCustomShiftModal())
                }
                else {
                    dispatch(toggleDefaultShiftModal())
                }
            });
    }
};

// GET CLOSED DAYS
export const GET_CLOSED_DAYS_REQUEST = "GET_CLOSED_DAYS_REQUEST";
export const GET_CLOSED_DAYS_SUCCESS = "GET_CLOSED_DAYS_SUCCESS";
export const GET_CLOSED_DAYS_ERROR = "GET_CLOSED_DAYS_ERROR";

export const getClosedDaysRequest = () => {
    return {
        type: GET_CLOSED_DAYS_REQUEST,
        loading: true
    };
};
export const getClosedDaysSuccess = (closedDays) => {
    return {
        type: GET_CLOSED_DAYS_SUCCESS,
        loading: false,
        error: null,
        closedDays
    };
};
export const getClosedDaysError = (error) => {
    return {
        type: GET_CLOSED_DAYS_ERROR,
        loading: false,
        error
    };
};
export const getClosedDays = () => {
    return dispatch => {
        dispatch(getClosedDaysRequest());
        axios.get(apis.GET_CLOSED_DAYS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getClosedDaysSuccess(response.data));
            })
            .catch(error => {
                dispatch(getClosedDaysError(errors.GET_CLOSED_DAYS_ERROR));
                notifyError(errors.GET_CLOSED_DAYS_ERROR);
            });
    }
};

// ADD CLOSED_DAY
export const ADD_CLOSED_DAY_REQUEST = "ADD_CLOSED_DAY_REQUEST";
export const ADD_CLOSED_DAY_SUCCESS = "ADD_CLOSED_DAY_SUCCESS";
export const ADD_CLOSED_DAY_ERROR = "ADD_CLOSED_DAY_ERROR";

export const addClosedDayRequest = () => {
    return {
        type: ADD_CLOSED_DAY_REQUEST,
        loading: true
    };
};
export const addClosedDaySuccess = (closedDay) => {
    return {
        type: ADD_CLOSED_DAY_SUCCESS,
        loading: false,
        error: null,
        closedDay
    };
};
export const addClosedDayError = (error) => {
    return {
        type: ADD_CLOSED_DAY_ERROR,
        loading: false,
        error
    };
};
export const addClosedDay = (closedDay) => {
    return dispatch => {
        dispatch(addClosedDayRequest());
        axios.post(apis.ADD_CLOSED_DAY_API, closedDay, getAxiosTokenConfig())
            .then(response => {
                dispatch(addClosedDaySuccess(response.data));
                notifySuccess(successes.ADD_CLOSED_DAY_SUCCESS)
            })
            .catch(error => {
                dispatch(addClosedDayError(errors.ADD_CLOSED_DAY_ERROR));
                notifyError(errors.ADD_CLOSED_DAY_ERROR);
            })
            .finally(() => dispatch(toggleClosedDayModal()));
    }
};

// UPDATE CLOSED_DAY
export const UPDATE_CLOSED_DAY_REQUEST = "UPDATE_CLOSED_DAY_REQUEST";
export const UPDATE_CLOSED_DAY_SUCCESS = "UPDATE_CLOSED_DAY_SUCCESS";
export const UPDATE_CLOSED_DAY_ERROR = "UPDATE_CLOSED_DAY_ERROR";

export const updateClosedDayRequest = () => {
    return {
        type: UPDATE_CLOSED_DAY_REQUEST,
        loading: true
    };
};
export const updateClosedDaySuccess = (closedDay) => {
    return {
        type: UPDATE_CLOSED_DAY_SUCCESS,
        loading: false,
        error: null,
        closedDay
    };
};
export const updateClosedDayError = (error) => {
    return {
        type: UPDATE_CLOSED_DAY_ERROR,
        loading: false,
        error
    };
};
export const updateClosedDay = (closedDay) => {
    return dispatch => {
        dispatch(updateClosedDayRequest());
        axios.patch(apis.UPDATE_CLOSED_DAY_API + closedDay.id + "/", closedDay, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateClosedDaySuccess(response.data));
                notifySuccess(successes.UPDATE_CLOSED_DAY_SUCCESS)
            })
            .catch(error => {
                dispatch(updateClosedDayError(errors.UPDATE_CLOSED_DAY_ERROR));
                notifyError(errors.UPDATE_CLOSED_DAY_ERROR);
            })
            .finally(() => dispatch(toggleClosedDayModal()));
    }
};

// DELETE CLOSED_DAY
export const DELETE_CLOSED_DAY_REQUEST = "DELETE_CLOSED_DAY_REQUEST";
export const DELETE_CLOSED_DAY_SUCCESS = "DELETE_CLOSED_DAY_SUCCESS";
export const DELETE_CLOSED_DAY_ERROR = "DELETE_CLOSED_DAY_ERROR";

export const deleteClosedDayRequest = () => {
    return {
        type: DELETE_CLOSED_DAY_REQUEST,
        loading: true
    };
};
export const deleteClosedDaySuccess = (closedDayId) => {
    return {
        type: DELETE_CLOSED_DAY_SUCCESS,
        loading: false,
        error: null,
        closedDayId
    };
};
export const deleteClosedDayError = (error) => {
    return {
        type: DELETE_CLOSED_DAY_ERROR,
        loading: false,
        error
    };
};
export const deleteClosedDay = (id) => {
    return dispatch => {
        dispatch(deleteClosedDayRequest());
        axios.delete(apis.DELETE_CLOSED_DAY_API + id + "/", getAxiosTokenConfig())
            .then(response => {
                dispatch(deleteClosedDaySuccess(id));
                notifySuccess(successes.DELETE_CLOSED_DAY_SUCCESS)
            })
            .catch(error => {
                dispatch(deleteClosedDayError(errors.DELETE_CLOSED_DAY_ERROR));
                notifyError(errors.DELETE_CLOSED_DAY_ERROR);
            })
            .finally(() => dispatch(toggleClosedDayModal()));
    }
};

// ADD SPECIAL OPENING
export const ADD_SPECIAL_OPENING_REQUEST = "ADD_SPECIAL_OPENING_REQUEST";
export const ADD_SPECIAL_OPENING_SUCCESS = "ADD_SPECIAL_OPENING_SUCCESS";
export const ADD_SPECIAL_OPENING_ERROR = "ADD_SPECIAL_OPENING_ERROR";

export const addSpecialOpeningRequest = () => {
    return {
        type: ADD_SPECIAL_OPENING_REQUEST,
        loading: true
    };
};
export const addSpecialOpeningSuccess = (shift) => {
    return {
        type: ADD_SPECIAL_OPENING_SUCCESS,
        loading: false,
        error: null,
        shift
    };
};
export const addSpecialOpeningError = (error) => {
    return {
        type: ADD_SPECIAL_OPENING_ERROR,
        loading: false,
        error
    };
};
export const addSpecialOpening = (shift, skipToggle) => {
    return dispatch => {
        dispatch(addSpecialOpeningRequest());
        axios.post(apis.ADD_SPECIAL_OPENING_API, shift, getAxiosTokenConfig())
            .then(response => {
                dispatch(addSpecialOpeningSuccess(response.data));
                notifySuccess(successes.ADD_SHIFT_SUCCESS)
            })
            .catch(error => {
                dispatch(addSpecialOpeningError(errors.ADD_SHIFT_ERROR));
                notifyError(errors.ADD_SPECIAL_OPENING_ERROR);
            })
            .finally(() => {
                if(skipToggle)
                    return;
                dispatch(toggleCustomShiftModal());
            });
    }
};


// WEBPACK FOOTER //
// ./src/store/actions/shifts.js